import Marquee from "react-fast-marquee";
import { MapPin } from "lucide-react";

const Item = ({ outline }) => (
  <span className="flex items-center gap-8 mx-8">
    <span className={`font-display font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tight ${outline ? "text-stroke-off" : "text-offwhite"}`}>
      CHARLOTTE, NC
    </span>
    <span className="inline-flex items-center gap-2 text-mustard shrink-0">
      <MapPin className="h-6 w-6 md:h-8 md:w-8" strokeWidth={2.2} />
    </span>
    <span className={`font-display font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tight ${outline ? "text-offwhite" : "text-stroke-off"}`}>
      & SURROUNDING AREAS
    </span>
    <span className="inline-flex items-center gap-2 text-mustard shrink-0">
      <MapPin className="h-6 w-6 md:h-8 md:w-8" strokeWidth={2.2} />
    </span>
  </span>
);

export default function ServiceAreaMarquee() {
  return (
    <section id="area" className="relative py-16 md:py-24 bg-petrol overflow-hidden" data-testid="service-area-section">
      <p className="text-center text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-mustard mb-8">
        Service Area
      </p>
      <Marquee speed={40} gradient={false} className="overflow-hidden">
        <Item outline={false} />
        <Item outline />
      </Marquee>
      <p className="text-center text-offwhite/60 font-light mt-8 px-5">
        Proudly serving Charlotte, NC and the surrounding area.
      </p>
    </section>
  );
}
